(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kerius-motion"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kerius-motion')) {
    customElements.define('kerius-motion', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.animations = new Set();
        this.seen = new WeakSet();
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.mobile = window.matchMedia('(max-width: 749px)');
        const signal = this.controller.signal;
        const start = () => {
          this.main = document.getElementById('MainContent');
          if (!this.main) return;
          this.configure();
          this.reducedMotion.addEventListener('change', () => this.configure(), { signal });
          document.addEventListener('shopify:section:load', (event) => this.observe(event.target), { signal });
          this.main.addEventListener('pointerdown', () => this.cancelAnimations(), { signal, passive: true });
          this.main.addEventListener('focusin', () => this.cancelAnimations(), { signal });
          this.main.addEventListener('keydown', () => this.cancelAnimations(), { signal });
          this.main.addEventListener('change', (event) => {
            if (!event.target.matches('.kerius-packs input[name="quantity"]')) return;
            const price = event.target.closest('kerius-packs')?.querySelector('[data-pack-button-price]');
            if (price) this.play(price, [
              { opacity: .65, transform: 'translateY(3px)' },
              { opacity: 1, transform: 'translateY(0)' }
            ], { duration: 180, easing: 'ease-out' });
          }, { signal });
        };
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', start, { once: true, signal });
        } else {
          start();
        }
      }
      configure() {
        this.observer?.disconnect();
        this.cancelAnimations();
        document.body.classList.toggle('kerius-motion-enabled', !this.reducedMotion.matches);
        if (this.reducedMotion.matches || !('IntersectionObserver' in window)) return;
        this.seen = new WeakSet();
        this.observer = new IntersectionObserver((entries) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            const target = entry.target;
            this.observer.unobserve(target);
            target.dataset.keriusMotion = 'revealed';
            const delay = target.matches('.mecanismo__paso')
              ? Math.min(Array.from(target.parentElement.children).indexOf(target), 2) * 65
              : 0;
            this.play(target, [
              { opacity: .35, transform: `translateY(${this.mobile.matches ? 10 : 16}px)` },
              { opacity: 1, transform: 'translateY(0)' }
            ], { duration: this.mobile.matches ? 400 : 520, delay, easing: 'cubic-bezier(.2,.65,.3,1)', fill: 'backwards' });
          }
        }, { rootMargin: '0px 0px -24px 0px', threshold: 0 });
        this.observe(this.main);
      }
      observe(root) {
        if (!this.observer || this.reducedMotion.matches || !root?.querySelectorAll) return;
        const selectors = [
          '.ke-story__copy', '.ke-story__media',
          '.kvs-title', '.kvs-lead', '.kvs-track',
          '.mecanismo__cabecera', '.mecanismo__media', '.mecanismo__paso',
          '.garantia__grid', '.faq__cabecera', '.faq__lista',
          '.comparativa__cabecera', '.comparativa__tabla-wrap', '.comparativa__cta',
          '.cta-final__contenido'
        ];
        for (const target of root.querySelectorAll(selectors.join(','))) {
          if (this.seen.has(target) || target.closest('.hero, [hidden]')) continue;
          this.seen.add(target);
          const rect = target.getBoundingClientRect();
          if (!rect.width || !rect.height || rect.top < window.innerHeight) {
            target.dataset.keriusMotion = 'static';
            continue;
          }
          target.dataset.keriusMotion = 'waiting';
          this.observer.observe(target);
        }
      }
      play(target, frames, timing) {
        if (this.reducedMotion.matches || !target.animate) return;
        const animation = target.animate(frames, timing);
        this.animations.add(animation);
        const remove = () => this.animations.delete(animation);
        animation.addEventListener('finish', remove, { once: true });
        animation.addEventListener('cancel', remove, { once: true });
      }
      cancelAnimations() {
        for (const animation of this.animations) animation.cancel();
        this.animations.clear();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.cancelAnimations();
        this.controller?.abort();
        this.controller = null;
        document.body.classList.remove('kerius-motion-enabled');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kerius-packs"] && !Shopify.designMode) return;
  try {
    (function () {
    const root = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    const CTA_SEL = 'a[href*="#kerius-packs"], a[data-kerius-cta], a[data-kerius-direct]';
    function packState() {
      const form = document.querySelector('kerius-packs form');
      if (!form) return null;
      const id = form.querySelector('input[name="id"]').value;
      const qtyInput = form.querySelector('input[name="quantity"]:checked') || form.querySelector('input[name="quantity"]');
      const qty = parseInt(qtyInput ? qtyInput.value : '1', 10) || 1;
      return { form: form, id: id, qty: qty, total: qtyInput ? qtyInput.dataset.packTotal : '' };
    }
    function goCheckout(id, qty, onFail) {
      const updates = {}; updates[id] = qty;
      fetch(root() + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ updates: updates }) })
        .then((r) => { if (!r.ok) throw new Error('cart'); return r.json(); })
        .then(() => { window.location.href = root() + 'checkout'; })
        .catch(onFail);
    }
    function packRadios() { return Array.prototype.slice.call(document.querySelectorAll('kerius-packs input[name="quantity"]')); }
    function buildBarSelect() {
      const bar = document.querySelector('.barra .barra__texto');
      if (!bar || bar.querySelector('.kerius-barra-select')) return;
      const radios = packRadios(); if (!radios.length) return;
      const sel = document.createElement('select');
      sel.className = 'kerius-barra-select';
      sel.setAttribute('aria-label', 'Elige tu pack');
      radios.forEach((r) => {
        const o = document.createElement('option');
        const q = parseInt(r.value, 10);
        o.value = r.value; o.textContent = q + (q === 1 ? ' unidad' : ' unidades');
        sel.appendChild(o);
      });
      sel.addEventListener('change', () => {
        const r = radios.find((x) => x.value === sel.value);
        if (r) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
      });
      const price = bar.querySelector('.barra__precio');
      if (price) price.style.display = 'none';
      bar.insertBefore(sel, bar.firstChild);
      const st = document.createElement('style');
      st.textContent = '.kerius-barra-select{appearance:none;-webkit-appearance:none;font:600 15px/1.2 "Hanken Grotesk",system-ui,sans-serif;color:#1a1a1a;background:#fff url("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2710%27 height=%276%27%3E%3Cpath d=%27M1 1l4 4 4-4%27 stroke=%27%231a1a1a%27 fill=%27none%27 stroke-width=%271.6%27/%3E%3C/svg%3E") no-repeat right 10px center;border:1px solid #c9b48f;border-radius:10px;padding:8px 28px 8px 10px;max-width:100%;min-width:0;margin:0 0 3px;cursor:pointer}';
      document.head.appendChild(st);
    }
    function syncCtas() {
      const st = packState();
      if (!st) return;
      buildBarSelect();
      const sel = document.querySelector('.kerius-barra-select'); if (sel) sel.value = String(st.qty);
      document.querySelectorAll('.barra__precio').forEach((p) => { if (st.total) p.textContent = st.total; });
      document.querySelectorAll(CTA_SEL).forEach((a) => {
        if (a.closest('kerius-packs')) return;
        if (!a.dataset.keriusDirect) {
          a.dataset.keriusDirect = '1';
          a.dataset.keriusLabel = a.textContent.split('—')[0].trim();
        }
        a.href = root() + 'cart/' + st.id + ':' + st.qty;
        const noPrice = a.hasAttribute('data-kerius-noprice');
        const isBarra = a.classList && a.classList.contains('barra__btn');
        const lbl = isBarra ? 'Comprar' : a.dataset.keriusLabel;
        a.textContent = lbl + (st.total && !noPrice ? ' — ' + st.total : '');
      });
    }
    document.addEventListener('click', (event) => {
      const a = event.target.closest && event.target.closest('a[data-kerius-direct]');
      if (!a || !window.fetch) return;
      const st = packState();
      if (!st) return;
      event.preventDefault();
      a.setAttribute('aria-busy', 'true');
      goCheckout(st.id, st.qty, () => { window.location.href = a.href; });
    });
    window.keriusSyncCtas = syncCtas;
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncCtas); else syncCtas();
    window.addEventListener('pageshow', syncCtas);

    if (!customElements.get('kerius-packs')) {
      customElements.define('kerius-packs', class extends HTMLElement {
        connectedCallback() {
          if (this.bound) return;
          this.bound = true;
          this.addEventListener('change', (event) => {
            if (!event.target.matches('input[name="quantity"]')) return;
            const price = this.querySelector('[data-pack-button-price]');
            if (price) price.textContent = event.target.dataset.packTotal;
            syncCtas();
          });
          const form = this.querySelector('form');
          if (form && window.fetch) {
            form.addEventListener('submit', (event) => {
              if (form.dataset.keriusNative === '1') return;
              event.preventDefault();
              event.stopImmediatePropagation();
              const btn = form.querySelector('.kerius-packs__submit');
              const st = packState();
              if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
              goCheckout(st.id, st.qty, () => { form.dataset.keriusNative = '1'; if (btn) btn.disabled = false; HTMLFormElement.prototype.submit.call(form); });
            }, true);
          }
        }
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
